import React from "react";
import { Modal, Box, Typography, Button, IconButton } from "@mui/material";
import { Delete, Visibility } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { format, parse, isValid } from "date-fns";
const styles = {
  modalBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90%", sm: 500 },
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: { xs: 2.5, sm: 4 },
    outline: "none",
    maxHeight: "80vh",
    overflowY: "auto",
  },
  headerBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: 3,
  },
  title: {
    color: "#F7A86E",
    fontWeight: 700,
  },
  shiftsList: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  shiftItem: (color) => ({
    p: 2,
    border: "1px solid #eee",
    borderRadius: 2,
    borderLeft: `5px solid ${color}`,
    bgcolor: "#fafafa",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }),
  buttonContainer: {
    mt: 3,
    textAlign: "center",
  },
  closeButton: {
    borderColor: "#F7A86E",
    color: "#F7A86E",
    textTransform: "none",
  },
};
const ViewShiftModal = ({ open, onClose, shifts, onDelete }) => {
  const { t } = useTranslation();
  return (
    <Modal open={open} onClose={onClose} keepMounted={false}>
      <Box sx={styles.modalBox}>
        <Box sx={styles.headerBox}>
          <Typography variant="h6" sx={styles.title}>
            {t("pages.shift_management.existing_shifts_title")}
          </Typography>
        </Box>
        {shifts.length === 0 ? (
          <Typography variant="body2" color="text.secondary" align="center">
            {t("pages.shift_management.no_shifts_created")}
          </Typography>
        ) : (
          <Box sx={styles.shiftsList}>
            {shifts.map((shift) => {
              const shiftId = shift.shift_key;
              return (
                <Box
                  key={shiftId || Math.random()}
                  sx={styles.shiftItem(shift.color)}
                >
                  <Box>
                    <Typography variant="subtitle2" fontWeight={700}>
                      {shift.shift_type}
                    </Typography>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      display="block"
                    >
                      {(() => {
                        const safe = (t) => {
                          if (!t) return "";
                          let d = parse(t, "HH:mm:ss", new Date());
                          if (isValid(d)) return format(d, "h:mm a");
                          d = parse(t, "h:mm a", new Date());
                          if (isValid(d)) return format(d, "h:mm a");

                          return t;
                        };
                        return `${safe(shift.start_time)} - ${safe(
                          shift.end_time
                        )}`;
                      })()}
                    </Typography>
                    <Typography
                      variant="caption"
                      display="block"
                      color="text.secondary"
                    >
                      Break: {shift.break_hours}h
                    </Typography>
                  </Box>
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      console.log("Deleting shift object:", shift);
                      if (shiftId) onDelete(shiftId);
                      else
                        console.error("No shift_key found for shift:", shift);
                    }}
                    color="error"
                    size="small"
                  >
                    <Delete />
                  </IconButton>
                </Box>
              );
            })}
          </Box>
        )}
        <Box sx={styles.buttonContainer}>
          <Button onClick={onClose} variant="outlined" sx={styles.closeButton}>
            {t("pages.shift_management.close")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
export default ViewShiftModal;
